import { getMultiProductsRating } from "@/services/product/reviews";
import { getCookies } from "cookies-next";
import { useCallback } from "react";
import useSWRMutation from "swr/mutation";
import useClearPLPProductsCache from "./useClearCachePLPProducts";
import { getProductsByCategoryId } from "@/services/category";

const useSortProducts = ({ setAllSortingKeys, setAllProducts, categoryID, allSortingKeys, allFilterKeys }) => {
  const { handshake } = getCookies()
  const { clearPLPProductsCache } = useClearPLPProductsCache(categoryID)
  
  const res = useSWRMutation(
    `/api/category/pages/getMoreProducts?pageIdx=0&categoryID=${categoryID}&${allSortingKeys}`,
    async (_, { arg }) => {
      return await getProductsByCategoryId(
        handshake,
        categoryID,
        arg?.pageSize,
        arg?.pageNo,
        arg?.filterKeys,
        arg?.sortKeys
      );
    },
    {
      revalidateOnMount: 30 * 60 * 1000, // 30 minutes in milliseconds
      revalidateIfStale: false,
      revalidateOnFocus: false,
      revalidateOnReconnect: false,
      populateCache: true,
    }
  );

  const handleSorting = useCallback(
    async ({ keys }) => {

      setAllSortingKeys(keys)
      clearPLPProductsCache()
      let resResult = await res?.trigger({
        pageNo: 0,
        pageSize: 30,
        categoryID,
        filterKeys: allFilterKeys,
        sortKeys: keys,
      });

      const result = resResult?.data?.data || {};

      if (result?.products?.length && result?.products != undefined) {
        const skus = [... new Set(...result?.products?.map(product => product?.sku))];
    
        const ratings = await getMultiProductsRating(skus?.flat(), handshake);
      
        const enhancedProducts = result?.products?.map(product => ({
          ...product,
          rating: Object.entries(ratings?.data?.data?.at(1))?.find(r => r?.at(0) === product?.sku)?.at(1) || { count: "0", rating: "0.0" },
        }))
        
        setAllProducts(enhancedProducts);
      }

    },

    [allFilterKeys, categoryID, clearPLPProductsCache, handshake, res, setAllProducts, setAllSortingKeys]
  );

  return {
    handleSorting,
  };
};

export default useSortProducts;
